import axiosInstance from "../utils/axios.js";
import axios from "axios";
import { API_URL } from "@/common/config.js";

export const ObjectApi = {
  async postAllObjects({
    from,
    count,
    companies,
    value,
    field,
    dealer,
    conditions,
    timezone_key,
    sortField,
    sortDesc,
  }) {
    const formData = {
      model: "units",
      companies: companies || [],
      from: from || 0,
      count: count || 100,
      field: field || "",
      value: value || "",
      conditions: conditions || [],
      timezone_key: timezone_key || "",
    };

    if (dealer && dealer.id) {
      formData.dealer = dealer;
    }
    // Старый формат условия {field, value} дублируем в строку поиска;
    // условия-фильтры {field, values: [...]} строку поиска не трогают
    if (Array.isArray(conditions) && conditions[0]?.value !== undefined) {
      formData.value = conditions[0]?.value || "";
      formData.field = conditions[0]?.field || "";
    }
    if (formData.companies.length <= 0) {
      delete formData.companies;
    }
    if (sortDesc !== "") {
      formData.sortDesc = sortDesc;
      formData.sortField = sortField;
    }

    const { data } = await axiosInstance.post("/admin_query", formData);

    return data;
  },
  async getPorts() {
    const { data } = await axiosInstance.get("/ports");

    return data;
  },

  async getObject() {
    const { data } = await axiosInstance.post("/units/list", {
      fields: [
        "id",
        "name",
        "imei",
        "icon",
        "type.value",
        "type.type",
        "phonenumber",
        "phonenumber2",
        "terminal_type.type",
        "terminal_type.value",
      ],
    });

    return data;
  },
  async getUnitsGroup() {
    const { data } = await axiosInstance.post("/unitsgroup/list", {
      fields: ["id", "name", "units.id", "units.name", "users.id"],
    });

    return data;
  },

  async deleteObjects(ids, deleteTerminals = false) {
    const config = deleteTerminals
      ? { data: { delete_terminals: true } }
      : {};
    const { data } = await axiosInstance.delete(`/units/${ids}`, config);

    return data;
  },

  async deleteUnits(ids) {
    const { data } = await axiosInstance.delete("/units", { data: { ids } });

    return data;
  },

  async deleteObject(id, deleteTerminals = false) {
    const config = deleteTerminals
      ? { data: { delete_terminals: true } }
      : {};
    const { data } = await axiosInstance.delete(`/units/${id}`, config);

    return data;
  },
  async deleteExternalIcon(id) {
    const { data } = await axiosInstance.delete("/external_icons", {
      params: { id },
    });

    return data;
  },

  async getParamsForUnit() {
    const { data } = await axiosInstance.get("/units/sensors/params");

    return data;
  },

  async analyzeWialon({ id, file }) {
    const files = new FormData();
    files.append("file", file);
    const { data } = await axiosInstance.post(
      `/loadwln/${id}/units/analyze_terminals`,
      files,
    );

    return data;
  },

  async analyzeParams({ id, terminals }) {
    try {
      const { data } = await axiosInstance.post(
        `/loadwln/${id}/units/analyze_params`,
        terminals,
      );

      return data;
    } catch (err) {
      throw new Error(err);
    }
  },

  async createParams({ id, info }) {
    const { data } = await axiosInstance.post(
      `/loadwln/${id}/units/create`,
      info,
    );

    return data;
  },
  // NEW UNITS
  async getObjectById(id) {
    const { data } = await axiosInstance.get(`/units?ids=${id}`);

    return data;
  },
  async createObject({ formData }) {
    const { data } = await axiosInstance.post("/units", formData);

    return data;
  },
  async addAccess(payload) {
    const { data } = await axiosInstance.post("/units/access", payload);

    return data;
  },
  async revokeAccess(payload) {
    const { data } = await axiosInstance.post("/units/access/revoke", payload);

    return data;
  },
  async updateObject({ id, formData }) {
    const { data } = await axiosInstance.put(`/units/${id}`, formData);

    return data;
  },
  async validateObject({ formData }) {
    const { data } = await axiosInstance.post("/units/validate", formData);

    return data;
  },
  getCustomFields(responseHandler, errorHandler) {
    axiosInstance
      .get("/custom_fields", { needAuth: true })
      .then(responseHandler)
      .catch(errorHandler);
  },
  // async getCustomFields() {
  //   const { data } = await axiosInstance.get('/custom_fields');

  //   return data;
  // },
  async postReport(params) {
    const { data } = await axiosInstance.post("/report_any", {
      ...params,
    });

    return data;
  },
  async getReportTemplates() {
    const { data } = await axiosInstance.get("/report_templates");

    return data;
  },
  // async copySensors(params) {
  //   const { data } = await axiosInstance.get(
  //     `/units/sensors/copy?ids=${params.id}`
  //   );

  //   return data;
  // },
  async unitsItemSensors(id) {
    const { data } = await axiosInstance.get(`/units/${id}/sensors`);

    return data;
  },
  async copySensor(ids) {
    const { data } = await axiosInstance.get(`/units/sensors/copy?ids=${ids}`);
    return data;
  },

  async copySensors(formData, responseHandler, errorHandler) {
    console.log(formData);
    return axiosInstance
      .post("/units/sensors/add_to_units", formData)
      .then(responseHandler)
      .catch(errorHandler);
  },

  searchObject({ formData }, responseHandler, errorHandler) {
    axiosInstance
      .post("/units/list", formData, { needAuth: true })
      .then(responseHandler)
      .catch(errorHandler);
  },

  getSensorsConnections(responseHandler, errorHandler) {
    axiosInstance
      .get("/units/sensors/connections")
      .then(responseHandler)
      .catch(errorHandler);
  },

  async postFileToObject(file, companyId) {
    const formData = new FormData();
    if (file) {
      formData.append("file", file);
    }
    const { data } = await axiosInstance.post(
      `/loadwln/${companyId}/units/add_services`,
      formData,
    );

    return data;
  },

  async postImportHistoryWln(payload) {
    try {
      return await axiosInstance.post(`/tools/loadwln`, payload.file, {
        params: {
          table: payload.table,
          imei: payload.imei,
        },
      });
    } catch (e) {
      console.log(e);
      return e;
    }
  },

  async exportHistory(payload) {
    return await axios.post(API_URL + `/tools/exportwln_multiple`, payload, {
      responseType: "blob",
    });
  },

  async loadExcelFile(payload) {
    try {
      return await axiosInstance.post("/admin_query_excel", payload, {
        responseType: "blob",
      });
    } catch (error) {
      return error;
    }
  },
};
